module.exports = __webpack_public_path__ + "img/warn_icon.a90dcfb5.svg";